module.exports = function(app) {
    app.controller('healthPlansRefine', ['$scope',
        function($scope) {



        }
    ]);
};